import React from "react"
import {IncomeOrExpenses, ProgressChartType, ProgressD3Chart} from "./progress-chart"
import InsightDataHelper from "../insight/insight-data-helper"
import styles from "./progress-chart.module.scss"

export interface ProgressChartAreaProps {
  type: ProgressChartType
  spendingData: InsightDataHelper
  showCo2: boolean
  clickCategoryMonth: (categoryId: number | undefined, monthIndex: number) => void
  selectedProgressCategoryId: number | null
  incomeOrExpenses?: IncomeOrExpenses
  noSubCategories?: boolean
}

export const ProgressChartArea : React.FC<ProgressChartAreaProps> = ({ spendingData, showCo2, clickCategoryMonth, selectedProgressCategoryId, incomeOrExpenses, noSubCategories = false }) => {
  return <div className={styles.ProgressChartArea}>
    <ProgressD3Chart
      spendingData={spendingData}
      showCo2={showCo2}
      clickCategoryMonth={clickCategoryMonth}
      selectedProgressCategoryId={selectedProgressCategoryId}
      incomeOrExpenses={incomeOrExpenses}
      noSubCategories={noSubCategories}/>
  </div>
}